// extracted by mini-css-extract-plugin
export var quotationEnd = "index-module--quotation-end--6931a";
export var review = "index-module--review--c1b2c";
export var reviewInContent = "index-module--review-in-content--56c0c";